import styled, { css } from 'styled-components';

const GOLD = '#E9B755';
export const CardWrapper = styled.div`
  display: flex;
  background: black;
  width: 400px;
  height: 590px;
  
  border-radius: 1rem;
  overflow: hidden;
  
  color: white;
  
  margin: 0 0 2rem 0;
`;

export const BodyWrapper = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-flow: row;
  width: 100%;
  margin-bottom: 1rem;
`;

export const AuthorBlock = styled.div`
  display: flex;
  flex-flow: row;
`;

export const ActionBlock = styled.div`
  display: flex;
  flex-flow: row;
  margin-left: auto;
  align-content: center;
  align-items: center;
  
  height: 10px;
  
  font-size: 0.8rem;
  
  text-transform: uppercase;
  
  border: 1px solid #fff;
  padding: 0.2rem 0.3rem;
  
  border-radius: 0.4rem;
`;

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 50px;
  width: 50px;

  ${(props) => props.imageUrl
          && css`
      background-image: url('${props.imageUrl}');
      background-size: cover;
      background-position: center;
    `}
  
  border: 2px solid ${GOLD};
  border-radius: 500rem;
  
  margin-right: 0.8rem;
  
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-flow: column;
`;

export const Name = styled.h1`
  display: flex;
  flex-flow: row;
  text-transform: uppercase;
  font-weight: 200;
  
  font-size: 0.9rem;
  padding: 0;
  margin: 0;
  
  span {
    font-weight: 800;
    margin-left: 0.5rem;
  }
`;

export const Title = styled.h2`
  display: flex;
  flex-flow: column;
  padding: 0;
  margin: 0.1rem 0;
  
  font-size: 0.9rem;
  font-weight: 300;
`;

export const Date = styled.span`
  display: flex;
  flex-flow: column;
  font-size: 0.8rem;
  
  text-transform: uppercase;
`;

export const MediaWrapper = styled.div`
  display: flex;
  flex-flow: column;
  border: 2px solid ${GOLD};
  border-radius: 1rem;
  
  padding: 0.5rem;
`;

export const MediaBody = styled.div`
  display: flex;
  flex-flow: column;
  
  img {
    width: 350px;
    height: auto;
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-flow: row;
  width: 100%;
  color: ${GOLD};
  
  font-weight: 600;
`;

export const MetaInventory = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1;
  padding: 0.5rem 0;
`;

export const MetaTagImg = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1;
  width: 100%;
  justify-content: center;
  align-items: center;
  
  margin-top: -30px;
  
  z-index: 1;
  
  img {
    width: 120px;
    height: auto;
  }
`;

export const MetaPrice = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1;
  padding: 0.5rem 0;
  align-items: flex-end;
`;

export const CardBackHeader = styled.div`
  color: white;
  display: flex;
  flex-flow: column;
  padding: 0.5rem 0;
  align-items: flex-end;
  height: 20px;
`;

export const CardBackTitle = styled.h1`
  text-transform: uppercase;
  font-weight: 200;

  font-size: 1rem;
  padding: 0;
  margin: 0.3rem 0;

  span {
    font-weight: 800;
    margin-left: 0.5rem;
  }
`;

export const CardBackDate = styled.p`
  text-transform: uppercase;
  font-weight: 200;

  font-size: 0.9rem;
  padding: 0;
  margin: 0 0 0.5rem 0;
`;

export const CardBackContentWrapper = styled.div`
  height: 180px;
  width: 100%;
  overflow: auto;
  //position: relative;
  padding: 0.5rem 0;
  margin: 0 0 1rem 0;
`;

export const CollectionWrapper = styled.div`
  p {
    text-transform: none;
  }
  margin: 0 0 1rem 0;
`;

export const CardBackContentInner = styled.div`
  width: 100%;
  position: relative;
`;
